/* Homepage-only progressive disclosure; all destination links work without JavaScript. */
(function () {
  'use strict';
  function mount(root) {
    if (root.dataset.enhanced) return;
    var panels = Array.from(root.querySelectorAll('[data-ib-photo-panel]'));
    if (!panels.length) return;
    var controls = panels.map(function (panel) { return panel.querySelector('.ib-photo-panel-select'); });
    function select(index) {
      panels.forEach(function (panel, i) {
        var open = i === index;
        panel.dataset.expanded = String(open);
        controls[i].setAttribute('aria-expanded', String(open));
        panel.querySelector('.ib-photo-panel-detail').hidden = !open;
      });
    }
    panels.forEach(function (panel, index) {
      var button = controls[index];
      var pointerFocus = false;
      button.disabled = false;
      button.addEventListener('pointerdown', function () { pointerFocus = true; });
      button.addEventListener('pointercancel', function () { pointerFocus = false; });
      button.addEventListener('blur', function () { pointerFocus = false; });
      button.addEventListener('click', function () { select(index); pointerFocus = false; });
      panel.addEventListener('focusin', function () { if (!pointerFocus) select(index); });
      panel.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width:901px) and (hover:hover) and (pointer:fine)').matches) return;
        if (root.contains(document.activeElement) && document.activeElement.matches(':focus-visible') && !panel.contains(document.activeElement)) return;
        select(index);
      });
      button.addEventListener('keydown', function (event) {
        pointerFocus = false;
        var next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % panels.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + panels.length - 1) % panels.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = panels.length - 1;
        else return;
        event.preventDefault();
        controls[next].focus();
      });
    });
    root.dataset.enhanced = 'true';
    select(0);
  }
  function init(context) { context.querySelectorAll('[data-ib-photo-panels]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
